import { assertNotNil, createFpiKey, logExceptionIntoSentry, type OperationError, useQuery } from 'venn-utils';
import {
  type FinancialPerformanceIndicatorsResponse,
  getFinancialPerformanceIndicators,
  type OperationResult,
} from 'venn-api';
import { useRecoilValue } from 'recoil';
import {
  blockLimitedHoldingsSubjectsWithFees,
  convertStudioSubjectToHoldingsSubject,
  proxySetIdState,
} from 'venn-state';

export const useFinancialPerformanceIndicatorsData = (id: string): FinancialPerformanceIndicatorsResponse => {
  const allSubjects = useRecoilValue(blockLimitedHoldingsSubjectsWithFees(id));
  const holdingsSubjects = allSubjects.map(convertStudioSubjectToHoldingsSubject);
  const proxySetId = useRecoilValue(proxySetIdState);

  const { data } = useQuery<FinancialPerformanceIndicatorsResponse, OperationResult<OperationError | undefined>>(
    createFpiKey(holdingsSubjects, proxySetId),
    async () => {
      const { content } = await getFinancialPerformanceIndicators(proxySetId ?? undefined, holdingsSubjects);
      return content;
    },
    {
      onError: (error) => {
        logExceptionIntoSentry(error);
      },
      suspense: true,
    },
  );

  return assertNotNil(data);
};
